
import { ChakraProvider, SystemContext } from '@chakra-ui/react';
import {
	ColorModeProvider,
	type ColorModeProviderProps,
} from './ColorMode';
import React from 'react';


type Props = { theme: SystemContext } & ColorModeProviderProps

export function Provider(props: Props) {
	const { theme, ...colorProviderProps } = props;
	return (
		<ChakraProvider value={theme}>
			<ColorModeProvider {...colorProviderProps} />
		</ChakraProvider>
	);
}
